import get from 'lodash/get';
import { TrackJS } from 'trackjs';

// For what percentage of the users do we want to track errors?
const enabledPercentage = __DEV__ === true ? 1 : 0.1;

// Extract root domain without extension or subdomain. eg. wtd05, lvh, wetransferbeta
const domainName = location.hostname.split('.').slice(-2)[0];
const applicationName = `frontend-${domainName}`;

// Certain errors we want to ignore
const ignoreRules = [
  /401 Unauthorized/,
  /409 Conflict/,
  /\/api\/v4\/accounts\/validate/,
  /\/api\/v4\/accounts\/signup\/validate/,
  /\/api\/v4\/accounts\/subdomains\/validate/,
  /\/api\/v4\/users\/validate/,
  /HumanVerificationRequired/,
  /UnableToParseMessage: MSFAPI/,
  /EmptyWallpaperCommand:.+nuanria_messaging/,
  /vid_mate_check/,
  /Not implemented/,
  /Non implémenté/,
];

// We don't want to send all our data to trackJS.
const obscureRules = [
  {
    // Transfer id
    re: new RegExp(/\/(\w{5})\w{10,24}(\d{14,17})\//g),
    replace: '/$1[XFER-ID]$2/',
  },
  {
    // Email addresses
    re: new RegExp(/[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,4})/g),
    replace: '[EMAIL]@[DOMAIN]$1',
  },
];

function ignoreError(payload) {
  return ignoreRules.some((rule) => rule.test(payload.message));
}

const onError = (payload) => {
  // `payload` is the actual JSON data that will get sent to trackJS
  if (ignoreError(payload)) {
    return false;
  }

  payload.console = JSON.stringify(payload.console);
  payload.nav = JSON.stringify(payload.nav);
  payload.network = JSON.stringify(payload.network);

  obscureRules.forEach(({ re, replace }) => {
    payload.console = payload.console.replace(re, replace);
    payload.nav = payload.nav.replace(re, replace);
    payload.network = payload.network.replace(re, replace);
    payload.url = payload.url.replace(re, replace);
  });

  payload.console = JSON.parse(payload.console);
  payload.nav = JSON.parse(payload.nav);
  payload.network = JSON.parse(payload.network);

  return true;
};

const init = () => {
  if (!window.__trackjs__) {
    return;
  }

  TrackJS.install({
    token: window.__trackjs__.token,
    application: applicationName,
    version: get(window, '__app_settings__.revision', 'unknown'),
    enabled: window.__trackjs__.enabled && Math.random() < enabledPercentage,
    onError,
  });

  window['__trackjs__'] = undefined;
};

init();

export { onError };
export default init;
